import { Injectable } from "@angular/core";

@Injectable({
	providedIn: "root"
})
export class DownloadService {
	constructor() {}

	public file(data: any, tipo: string, nome: string, formato: string) {
		const blob = new Blob([data], { type: tipo });
		const url = window.URL.createObjectURL(blob);
		const anchor = document.createElement("a");
		anchor.download = `${nome}.${formato.toLowerCase()}`;
		anchor.href = url;
		anchor.click();
		window.URL.revokeObjectURL(url);
	}
}
